export const environment = {
  API_ENDPOINT: '/api',
  DEFAULT_THEME: 'light',
  DEFAULT_LANG: 'ru',
};
